import type { TimeSeriesItem } from '@/types/TimeSeriesItem';
import { useHttpClient } from '@/composables/useHttpClient';

/**
 * Retreives CLP from startDt to endDt for given profile name. Returns kW
 *
 * @param {string} profileName
 * @param {Date} startDt
 * @param {Date} endDt
 * @param {string} scaleFactor
 */
export const getScaledCLPTimeSeries = async (
  profileName: string,
  startDt: Date,
  endDt: Date,
  scaleFactor: number
) => {
  const { clpApi } = useHttpClient()

  try {
    const url = `/app/CLP/${encodeURIComponent(profileName)}/${startDt.getFullYear()}-${startDt.getMonth() + 1}-${startDt.getDate()}/${endDt.getFullYear()}-${endDt.getMonth() + 1}-${endDt.getDate()}`
    const clpResult = await clpApi.get(url)
    const clps = clpResult?.data?.data?.map((timeslice) => scale(timeslice, scaleFactor)) ?? []

    return clps
  } catch (err) {
    console.error('failed to fetch CLP', err)
  }
}

const scale = ({ v, endt }, scaleFactor): TimeSeriesItem => {
  return {
    v: parseFloat(v) * scaleFactor * 4,
    endt: new Date(endt),
    startt: new Date(new Date(endt).getTime() - 15 * 60 * 1000)
  } //times 4 i.e. kWh in 15min --> kW;
}
